(function () {
    'use strict';

    angular
        .module('cloudApp')
        .controller('IpAddressDialogController', IpAddressDialogController);

    IpAddressDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Peering', 'DbhawkIpAddressService', '$http'];

    function IpAddressDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, Peering, DbhawkIpAddressService, $http) {
        var vm = this;

        vm.clear = clear;
        vm.save = save;
        vm.change = change;
        vm.ipAddressOptions = ["Custom", "Anywhere", "My IP"];
        vm.ipAddressOption = vm.ipAddressOptions[0];
        vm.ipAddress = "0.0.0.0/0";

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function change() {
            if (vm.ipAddressOption === vm.ipAddressOptions[1]) {
                vm.ipAddress = "0.0.0.0/0";
            } else if (vm.ipAddressOption === vm.ipAddressOptions[2]) {
                $http.get("https://api.ipify.org/?format=json").then(function (response) {
                    vm.ipAddress = response.data.ip + "/32";
                });
            }
        }

        function save() {
            vm.isSaving = true;
            vm.error = null;

            DbhawkIpAddressService.addIpAddress(vm.ipAddress, $stateParams.instanceId).then(function (response) {
                vm.success = 'OK';
                $uibModalInstance.close(true);
            }).catch(function (response) {
                vm.isSaving = false;
                vm.error = 'ERROR';
            });
        }
    }
})();
